module.exports = __webpack_public_path__ + "img/Villa_Borna_36.6bed9e65.jpg";